<template>
  <div class="survey">
    <span class="md-display-1 margin-display">{{ title }}</span>
    <md-content v-if="!complete" class="md-elevation-4 md-alignment-center-center card-meoempresas">
      <div v-for="(item, ind) in questions" v-bind:key="ind">
          <question-rating
            v-if="item.type_field.description === 'rating'"
            :question="item.description"
            :rate="parseInt(item.type_field.settings.rate)"
            :badValue="parseInt(item.type_field.settings.bad)"
            :comment="item.type_field.settings.comment"
            @changeData="item.comment = $event"
            @isValid="isSurveyComplete(ind, $event)"
            v-model="item.answer"></question-rating>
          <question-radio
            v-if="item.type_field.description === 'radio'"
            :question="item.description"
            :options="item.type_field.settings.options"
            :badValue="item.type_field.settings.badValue"
            @changeData="item.comment = $event"
            @isValid="item.valid = $event"
            v-model="item.answer"
            ></question-radio>
      </div>
    </md-content>
    <div v-if="!complete">
      <md-button
        class="md-raised md-primary"
        :disabled="!isValid"
        @click="submit">
          Enviar
      </md-button>
    </div>
    <complete :text="text" v-if="complete"></complete>
  </div>
</template>

<script>
import QuestionRating from '@/components/QuestionRating.vue'
import QuestionRadio from '@/components/QuestionRadio.vue'
import Complete from '@/components/Complete.vue'
import Api from '@/api'

export default {
  name: 'survey',
  data () {
    return {
      token: null,
      data: [],
      questions: [],
      title: '',
      isValid: false,
      complete: false,
      error: '',
      text: 'Concluído'
    }
  },
  methods: {
    isSurveyComplete (index, item) {
      this.questions[index].valid = item
      if (this.questions.length) {
        this.isValid = this.questions.every(item => {
          return item.valid
        })
      }
    },
    sanitizer (question) {
      var result = question
      var keys = Object.keys(this.data.survey)
      keys.forEach(item => {
        if (result.includes('{' + item + '}')) {
          Object.entries(this.data.survey).forEach(([key, val]) => {
            if (key === item) {
              result = result.replace('{' + item + '}', val)
            }
          })
        }
      })
      return result
    },
    async submit () {
      this.$loading(true)
      let ansersCleared = this.questions.every(element => {
        return element.answer !== null
      })
      if (!ansersCleared) {
        this.$swal({
          type: 'warning',
          title: 'Atenção',
          text: 'É obrigatório responder todas as questões para submeter!'
        })
      } else {
        if (this.$route.query.hasOwnProperty('source')) {
          this.questions[0].source = this.$route.query.source
        }
        Api.Survey.post(this.questions).then(response => {
          this.$loading(false)
          this.complete = true
        }).catch(error => {
          this.error = error
          this.$loading(false)
          this.$swal({
            type: 'warning',
            title: 'Atenção',
            text: 'Não foi possível enviar o inquerito, tente novamente!'
          })
        })
      }
    }
  },
  components: {
    QuestionRating,
    QuestionRadio,
    Complete
  },
  mounted () {
    this.$loading(true)
    this.token = this.$route.params.token
    Api.Survey.show(this.token).then(response => {
      this.data = response.data
      if (this.data.survey.expired === 'Expired') {
        this.$router.push({ name: 'networkErrorPage' })
      }
      // var date = this.data.survey.expire_date.split('-')
      // var year = parseInt(date[0])
      // var d = date[2].split('T')
      // var day = parseInt(d[0])
      // var month = parseInt(date[1])
      // var ex = new Date(month, day, year)
      // var today = new Date()
      // var expired = (parseInt(ex.getTime() / 1000) - parseInt(today.getTime() / 1000)) / (1000 * 3600 * 24)
      // // if (expired < 0) {
      // ex = ex.getTime() / 1000
      // today = today.getTime() / 1000
      // this.complete = true
      // this.text = '' + ex + ' ----- ' + today + ' h ' + expired
      // // this.$router.push({ name: 'networkErrorPage' })
      // // }
      if (this.data.has_responsed === true) {
        this.complete = true
        this.text = 'Avaliação efetuada'
      }
      this.title = response.data.survey.template.description
      this.questions = response.data.survey.template.question.map(object => {
        var item = object
        item.valid = false
        item.description = this.sanitizer(item.description)
        item.answer = ''
        item.comment = ''
        item.participant = this.$route.params.token
        return item
      })
      this.$loading(false)
    }).catch(error => {
      this.$loading(false)
      if (error.response) {
        this.$router.push({ name: 'networkErrorPage' })
      } else {
        this.$router.push({ name: 'errorPage' })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.survey {
  margin: 10px;
}
.card-meoempresas {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1000px;
  min-height: 45vh;
}
</style>
